import ForbiddenError from './ForbiddenError';

export default ForbiddenError;
